export default function durationText (totalMinutes) {
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  const hoursText = hours ? `${hours}h` : ''
  const minutesText = minutes ? `${minutes}mn` : ''
  return hoursText + minutesText
}
